import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '../../translate/translate.module';
import {
  ButtonDropdownModule,
  ButtonModule,
  FormElementsModule,
  ModalDialogLayoutModule,
  PagingControlModule,
} from '@lib/ui';
import { BarRatingModule } from 'ngx-bar-rating';
import { FormattedTextViewerModule, ListItemsTableModule } from '@modules';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NotificationsModule } from '@lib/notifications';
import { ModalPatientsHistoryConsultationComponent } from './modal-patients-history-consultation.component';

@NgModule({
  declarations: [ModalPatientsHistoryConsultationComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ModalDialogLayoutModule,
    FormElementsModule,
    ButtonModule,
    BarRatingModule,
    ListItemsTableModule,
    ButtonDropdownModule,
    NotificationsModule,
    PagingControlModule,
    MatProgressSpinnerModule,
    FormattedTextViewerModule,
  ],
  exports: [ModalPatientsHistoryConsultationComponent],
})
export class ModalPatientsHistoryConsultationModule {}
